import api from "./axios";
import {
  AcessoHistorico,
  AcessoOrganizacao,
  AcessoPerfil,
  AcessoPessoa,
  ConviteRequest,
} from "../interfaces/acessos";

/**
 * Pessoas de uma organização cliente (`/api/acessos`). Quem pode agir em qual organização é decidido
 * pelo backend (`identidade.admin` em qualquer uma; `org.people.manage` só na própria).
 */
const base = (orgId: number) => `/acessos/${orgId}`;

/** Organizações em que a pessoa pode agir. Lista vazia = sem acesso à tela. */
export const getOrganizacoesAcesso = async (): Promise<AcessoOrganizacao[]> =>
  (await api.get("/acessos/organizacoes")).data;

export const getPessoasAcesso = async (orgId: number): Promise<AcessoPessoa[]> =>
  (await api.get(`${base(orgId)}/pessoas`)).data;

/** Perfis que quem concede pode atribuir naquela organização. */
export const getPerfisAcesso = async (orgId: number): Promise<AcessoPerfil[]> =>
  (await api.get(`${base(orgId)}/perfis`)).data;

/** 201 `{ pessoaId }`; 409 se a pessoa já tem acesso; 400 se o perfil não pode ser concedido. */
export const convidarPessoa = async (orgId: number, corpo: ConviteRequest): Promise<{ pessoaId: number }> =>
  (await api.post(`${base(orgId)}/convites`, corpo)).data;

export const definirPerfilAcesso = async (orgId: number, pessoaId: number, perfilId: number): Promise<void> => {
  await api.put(`${base(orgId)}/pessoas/${pessoaId}/perfil`, { perfilId });
};

/** 400 se a pessoa for quem está agindo. */
export const desativarPessoa = async (orgId: number, pessoaId: number): Promise<void> => {
  await api.post(`${base(orgId)}/pessoas/${pessoaId}/desativar`);
};

/** Sem `perfilId`, volta com o perfil anterior. */
export const reativarPessoa = async (orgId: number, pessoaId: number, perfilId?: number): Promise<void> => {
  await api.post(`${base(orgId)}/pessoas/${pessoaId}/reativar`, perfilId ? { perfilId } : {});
};

/** 400 se a pessoa já criou a senha. */
export const reenviarConvite = async (orgId: number, pessoaId: number): Promise<void> => {
  await api.post(`${base(orgId)}/pessoas/${pessoaId}/reenviar-convite`);
};

/** 50 por página, mais recentes primeiro. */
export const getHistoricoAcesso = async (orgId: number, pagina = 1): Promise<AcessoHistorico> =>
  (await api.get(`${base(orgId)}/historico`, { params: { pagina } })).data;
